export const ROOT_ID = 'o-spy';
